export const FILTER_NAME = 'purchase_order'
